/* eslint-disable */
import { PluginContainerData } from './common';
const baseTableData = {};
export const TableData = {
    fromJSON(object) {
        const message = Object.assign({}, baseTableData);
        message.containerData =
            object.containerData !== undefined && object.containerData !== null
                ? PluginContainerData.fromJSON(object.containerData)
                : undefined;
        message.dimensions =
            object.dimensions !== undefined && object.dimensions !== null
                ? TableData_Dimensions.fromJSON(object.dimensions)
                : undefined;
        message.header =
            object.header !== undefined && object.header !== null ? Boolean(object.header) : undefined;
        message.rowHeader =
            object.rowHeader !== undefined && object.rowHeader !== null
                ? Boolean(object.rowHeader)
                : undefined;
        message.columnHeader =
            object.columnHeader !== undefined && object.columnHeader !== null
                ? Boolean(object.columnHeader)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.containerData !== undefined &&
            (obj.containerData = message.containerData
                ? PluginContainerData.toJSON(message.containerData)
                : undefined);
        message.dimensions !== undefined &&
            (obj.dimensions = message.dimensions
                ? TableData_Dimensions.toJSON(message.dimensions)
                : undefined);
        message.header !== undefined && (obj.header = message.header);
        message.rowHeader !== undefined && (obj.rowHeader = message.rowHeader);
        message.columnHeader !== undefined && (obj.columnHeader = message.columnHeader);
        return obj;
    },
};
const baseTableData_Dimensions = { colsWidthRatio: 0, rowsHeight: 0, colsMinWidth: 0 };
export const TableData_Dimensions = {
    fromJSON(object) {
        var _a, _b, _c;
        const message = Object.assign({}, baseTableData_Dimensions);
        message.colsWidthRatio = ((_a = object.colsWidthRatio) !== null && _a !== void 0 ? _a : []).map((e) => Number(e));
        message.rowsHeight = ((_b = object.rowsHeight) !== null && _b !== void 0 ? _b : []).map((e) => Number(e));
        message.colsMinWidth = ((_c = object.colsMinWidth) !== null && _c !== void 0 ? _c : []).map((e) => Number(e));
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.colsWidthRatio) {
            obj.colsWidthRatio = message.colsWidthRatio.map(e => Math.round(e));
        }
        else {
            obj.colsWidthRatio = [];
        }
        if (message.rowsHeight) {
            obj.rowsHeight = message.rowsHeight.map(e => Math.round(e));
        }
        else {
            obj.rowsHeight = [];
        }
        if (message.colsMinWidth) {
            obj.colsMinWidth = message.colsMinWidth.map(e => Math.round(e));
        }
        else {
            obj.colsMinWidth = [];
        }
        return obj;
    },
};
//# sourceMappingURL=plugin_table.js.map